module.exports = __webpack_public_path__ + "static/media/lane_forward_arrow.5188ba8f.svg";